import { useNavigate } from 'react-router-dom';
import { PRODUTO_CONFIG } from 'config/produto';
import { getProduto } from 'config/produto-env';
import { usePeriodoFase } from 'hooks/useControlDate';
import { formatarDiaMesAno } from 'utils/cronograma';
import { ROTA_PRE_INSCRICAO, SituacaoPreInscricao } from 'utils/destino-inicial';

const EDICAO = `${PRODUTO_CONFIG.titulo} 2027`;

interface Aviso {
  linhas: string[];
  actionLabel: string;
  actionPath: string;
}

/**
 * Uma notificação para cada coisa que a pessoa ainda pode fazer: ver o que já
 * pré-inscreveu e cadastrar na vaga que sobrou (Conexão tem uma por subcategoria).
 * `fimPreInscricao` vem da controle_datas__c.
 */
function montarAvisos(situacao: SituacaoPreInscricao, fimPreInscricao: string): Aviso[] {
  const avisos: Aviso[] = [];

  if (situacao.temIniciativa) {
    avisos.push({
      linhas: [
        `Você tem iniciativa pré-inscrita no ${EDICAO}.`,
        fimPreInscricao && `A edição estará disponível até ${fimPreInscricao}.`,
      ].filter(Boolean) as string[],
      actionLabel: 'VER PRÉ-INSCRIÇÃO',
      actionPath: '/listagem',
    });
  }

  if (situacao.podeCadastrar) {
    avisos.push({
      linhas: [
        !situacao.temIniciativa
          ? `A pré-inscrição do ${EDICAO} está aberta! Pré-inscreva a sua iniciativa.`
          : situacao.categoriaLivre
            ? `Você ainda pode pré-inscrever uma iniciativa em ${situacao.categoriaLivre}.`
            : 'Você ainda pode pré-inscrever outra iniciativa.',
      ],
      actionLabel: 'FAZER PRÉ-INSCRIÇÃO',
      actionPath: ROTA_PRE_INSCRICAO,
    });
  }

  return avisos;
}

interface PreInscricaoNotificationProps {
  situacao: SituacaoPreInscricao | null;
  /** Ícone de aviso da home do produto (cada home tem o seu). */
  icone: string;
}

/**
 * Notificações da home durante a pré-inscrição: acompanhar a inscrição e/ou se inscrever.
 * Usa o mesmo `notification-banner` dos avisos da home; o estilo vem da página.
 */
export function PreInscricaoNotification({ situacao, icone }: PreInscricaoNotificationProps) {
  const navigate = useNavigate();
  const { phaseIds } = PRODUTO_CONFIG;
  const periodo = usePeriodoFase(
    getProduto() === 'PREMIO_ELBB' ? phaseIds.ELBB_PRE_REGISTRATION : phaseIds.CONEXAO_PRE_REGISTRATION
  );

  if (!situacao) {
    return null;
  }

  const avisos = montarAvisos(situacao, periodo ? formatarDiaMesAno(periodo.fim) : '');

  return (
    <>
      {avisos.map(({ linhas, actionLabel, actionPath }) => (
        <section key={actionPath} className="notification-banner">
          <div className="notification-banner__content">
            <img src={icone} alt="" aria-hidden="true" className="notification-banner__icon" />
            <p className="notification-banner__text">
              {linhas.map((linha, i) => (
                <span key={i} className="block">
                  {linha}
                </span>
              ))}
            </p>
            <button className="notification-banner__btn" onClick={() => navigate(actionPath)}>
              {actionLabel}
            </button>
          </div>
        </section>
      ))}
    </>
  );
}
